export type LegalPage = 'imprint' | 'privacy';

export type Route =
  | { name: 'home' }
  | { name: 'platformLegal'; page: LegalPage }
  | { name: 'booking'; slug: string }
  | { name: 'my'; slug: string }
  | { name: 'legal'; slug: string; page: LegalPage }
  | { name: 'notFound' };

export type TenantRoute = Extract<Route, { slug: string }>;

const LEGAL: Record<string, LegalPage> = { impressum: 'imprint', datenschutz: 'privacy' };

/** Customer URLs: /s/<slug>/, /s/<slug>/me, /s/<slug>/impressum, /s/<slug>/datenschutz (the staff app lives on its own origin). */
export function parseRoute(pathname: string): Route {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/') return { name: 'home' };
  const platform = /^\/(impressum|datenschutz)$/.exec(path);
  if (platform) return { name: 'platformLegal', page: LEGAL[platform[1]!]! };
  const m = /^\/s\/([a-z0-9-]+)(?:\/(me|impressum|datenschutz))?$/.exec(path);
  if (!m) return { name: 'notFound' };
  const slug = m[1]!;
  const sub = m[2];
  if (sub === 'me') return { name: 'my', slug };
  if (sub === 'impressum' || sub === 'datenschutz') return { name: 'legal', slug, page: LEGAL[sub]! };
  return { name: 'booking', slug };
}

/** Intercepts clicks on <a data-link> for client-side navigation. */
export function interceptLinks(navigate: (path: string) => void): void {
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = (e.target as Element).closest?.('a[data-link]');
    if (!(a instanceof HTMLAnchorElement) || a.origin !== location.origin) return;
    e.preventDefault();
    navigate(a.pathname);
  });
}
